export class Rating {
	constructor(category: string, description: string | null, rating: number) {
		this.category = category;
		this.description = description;
		this.rating = rating;
	}

	category: string;
	description: string | null;
	rating: number;
}